import './treatmentTypeGalleryHeader.scss';

import { IonSlide } from '@ionic/react';
import defaultPicture from 'application/pages/Treatments/images/treatment-default-picture.jpg';
import type { MediaData } from 'application/types';
import * as React from 'react';
import { useContextTranslation } from 'ui/translation';

import SwiperWithNavigation from './SwiperWithNavigation/SwiperWithNavigation';

interface BeforeContentGalleryProps {
  media: MediaData[];
}

const SLIDER_OPTIONS = {
  touchReleaseOnEdges: true,
  longSwipes: false,
  preloadImages: true,
};

export const defaultMedia: MediaData[] = [
  {
    type: 'video',
    uri: '/treatment-default-video.mp4',
  },
  {
    type: 'image',
    uri: defaultPicture,
  },
];

const BeforeContentGallery = ({
  media,
}: BeforeContentGalleryProps): JSX.Element => {
  const t = useContextTranslation('misc');
  const slider = React.useRef<HTMLIonSlidesElement>(null);

  return (
    <div className="treatment-type-gallery-header">
      <SwiperWithNavigation
        slider={slider}
        options={SLIDER_OPTIONS}
        key={media[0]?.uri || 'default_slides'}
      >
        {media?.map(mediaItem => (
          <IonSlide key={mediaItem.uri}>
            {mediaItem.type === 'video' ? (
              <video
                playsInline
                controls={false}
                src={mediaItem.uri}
                muted
                autoPlay
                loop
              />
            ) : (
              <img src={mediaItem.uri} alt={t('media')} />
            )}
          </IonSlide>
        ))}
      </SwiperWithNavigation>
    </div>
  );
};

export default BeforeContentGallery;
